export default {
	message: 'Are you sure that you saved the keys in a safe way?',

	submit: 'Yes, i saved',
	cancel: 'Back',
}
